module.exports = __webpack_public_path__ + "img/logo-p1.80ee4632.png";